/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import useSnackbar from "../../../hook/use-snakbar";
import { getErrorDetailsFn, getInputFieldProps } from "../../../utils/common";
import { logger, safeString } from "../../../utils/logger";
import { DESIGNATION_API, DESIGNATION_INITIAL_STATE, DESIGNATION_INPUT_FIELDS } from "./designation-constant";
import { designationValidationSchema } from "./designation-validation";

const useDesignationService = () => {
  const [resource, setResource] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
    totalPages: 1,
    hasMore: false,
  });

  const [desinagtionState, setdesinagtionState] = useState(structuredClone(DESIGNATION_INITIAL_STATE));
  const [open, setOpen] = useState(false);
  const handleClickOpen = (_, data) => {
    setErrors({});
    setdesinagtionState(data ? data : structuredClone(DESIGNATION_INITIAL_STATE));

    setOpen(true)

  };
  const handleClose = () => setOpen(false);
  const { fetchData } = useAPIHandler();
  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();

  // useEffect(() => {
  //   setResource(fetchDataWithPromise(DESIGNATION_API.DESIGNATION_LIST.URL))
  //   fetchData({ ...DESIGNATION_API.DEPARTMENT_LIST }).then(
  //     (res) => {
  //       const list = res?.data?.departments
  //         ?.filter(it => it?.status)
  //         ?.map(it => ({ name: it?.deptName, id: it?.department_id })) || [];
  //       if (list.length > 0) {

  //         setDepartmentList(list);
  //       }
  //     }
  //   );
  // }, []);

  useEffect(() => {
    // setResource(fetchDataWithPromise(DESIGNATION_API.DESIGNATION_LIST.URL));
    fetchData({ ...DESIGNATION_API.DEPARTMENT_LIST }).then((res) => {
      const list =
        res?.data?.departments
          ?.filter((it) => it?.status)
          ?.map((it) => ({ name: it?.deptName, id: it?.department_id })) || [];
      if (list.length > 0) {
        setDepartmentList(list);
      }
    });
    fetchDesignations(pagination.page, pagination.pageSize);
  }, [pagination.page, pagination.pageSize]);

  const [errors, setErrors] = useState({});

  const handleChangeFunction = (e, name) => {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    if (
      DESIGNATION_INPUT_FIELDS[name].customOptions &&
      DESIGNATION_INPUT_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = DESIGNATION_INPUT_FIELDS[name].customOptions?.formatValueFn(
        value,
        desinagtionState
      );
    }

    setdesinagtionState((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = designationValidationSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      //   context: { allowanceType: allowance.allowanceType },
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  };


  const getInputFieldPropsFn = (fieldName = "") => {
    const { customOptions = {}, ...restProps } =
      DESIGNATION_INPUT_FIELDS[fieldName] || {};

    let disabled = !!restProps.disabled;
    if (desinagtionState.isDisableEsi === true) {
      disabled = true;
    }

    const error = safeString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: desinagtionState,
        type: restProps.type || "text",
        error,
        handleChangeFunction,
      }),
      disabled,
    };


    return props;
  };
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);


  // const fetchDesignations = async (page, pageSize) => {
  //   try {
  //     const response = await fetchData({
  //       ...DESIGNATION_API.DESIGNATION_LIST,
  //       params: { page, pageSize },
  //     });
  //     if (response?.status === "success") {
  //       const { designations, total } = response.data;
  //       setDesignations(designations || []);
  //       setPagination({
  //         page: Number(total.page),
  //         pageSize: Number(total.pageSize),
  //         totalPages: Number(total.totalPages),
  //         hasMore: total.hasMore,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching designations:", error);
  //   }
  // };

  const fetchDesignations = async (page = 1, pageSize = 5) => {
    try {
      const URL = `/designation?page=${page}&pageSize=${pageSize}`;
      const METHOD = "GET";
      
      const result = await fetchData({ url: URL, method: METHOD });
      
      setDesignations(result?.data?.designations || []);
      setPagination({
        page: result?.data?.total?.page || 1,
        pageSize: result?.data?.total?.pageSize || 20,
        total: result?.data?.total?.total || 0,
        totalPages: result?.data?.total?.totalPages || 1,
      });
    } catch (error) {
      logger.log(error);
      openSnackbar({ message: "Error fetching leave policies", color: "danger" });
    }
  };

  // const handleNextPage = () => {
  //   if (pagination.page < pagination.totalPages) {
  //     setPagination((prev) => ({ ...prev, page: prev.page + 1 }));
  //   }
  // };

  // const handlePrevPage = () => {
  //   if (pagination.page > 1) {
  //     setPagination((prev) => ({ ...prev, page: prev.page - 1 }));
  //   }
  // };

  // const handlePageSizeChange = (newSize) => {
  //   setPagination({ page: 1, pageSize: newSize, totalPages: 1, hasMore: false });
  // };

  const handleSubmitFn = async () => {
    let URL, METHOD;
    if (desinagtionState?.designationId) {
      URL = DESIGNATION_API.DESIGNATION_UPDATE.url + desinagtionState?.designationId;
      METHOD = DESIGNATION_API.DESIGNATION_UPDATE.method;
    } else {
      URL = DESIGNATION_API.DESIGNATION_CREATE.url;
      METHOD = DESIGNATION_API.DESIGNATION_CREATE.method;
    }




    const {
      status,
      designationName,
      dept_id
    } = desinagtionState;


    const payload = {
      data: {
        status,
        designationName,
        dept_id
      },
      url: URL,
      method: METHOD,
    };




    const { error } = designationValidationSchema.validate(
      {
        status,
        designationName,
        dept_id
      },
      {
        abortEarly: false,
      }
    );




    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
    } else {
      setCreateUpdateLoading(true);

      try {
        await fetchData(payload);
        // setResource(fetchDataWithPromise(DESIGNATION_API.DESIGNATION_LIST.URL));






        openSnackbar({
          message: `Designation ${desinagtionState?.designationId ? "Update" : "Added"} succesfully!`,
          color: "success",
        });
        fetchDesignations()









        setOpen(false);

      } catch (error) {
        setCreateUpdateLoading(false);
        const { message, errorObj } = getErrorDetailsFn(error);

        openSnackbar({
          message,
          color: "danger",
        });
        setErrors(errorObj);
      } finally {
        setCreateUpdateLoading(false);
      }
    }
  };


  return {
    resource,
    departmentList,
    getInputFieldPropsFn,
    handleClickOpen, handleClose, open,
    handleSubmitFn,
    createUpdateLoading, setCreateUpdateLoading,
    desinagtionState,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    designations,
    pagination,
    fetchDesignations
  }

}
export default useDesignationService